import BaseRepository from "~/repositories/BaseRepository";

class RemainingProofreaderCountsRepository extends BaseRepository {
  async show(): Promise<any> { // eslint-disable-line @typescript-eslint/no-explicit-any
    const url = "/api/v1/users/remaining_proofreader_count";
    const result = await this._get(url);
    return result.data;
  }
}
export default RemainingProofreaderCountsRepository;
